import { FC, useMemo } from 'react';
import DOMPurify from 'dompurify';
import { Box, BoxProps } from '@mui/material';

// ==============================|| SAFE HTML (rich text sanitizat) ||============================== //
// Randează HTML din editorul rich-text, sanitizat cu DOMPurify (stil template).

interface SafeHtmlProps {
	html?: string;
	sx?: BoxProps['sx'];
}

export const SafeHtml: FC<SafeHtmlProps> = ({ html, sx }) => {
	const clean = useMemo(() => DOMPurify.sanitize(html ?? ''), [html]);

	return (
		<Box
			sx={{
				color: 'text.secondary',
				'& p': { m: 0, mb: 1 },
				'& p:last-child': { mb: 0 },
				'& ul, & ol': { pl: 2.5, m: 0, mb: 1 },
				'& a': { color: 'primary.main' },
				'& strong': { color: 'text.primary' },
				'& img': { maxWidth: '100%' },
				...sx
			}}
			dangerouslySetInnerHTML={{ __html: clean }}
		/>
	);
};

SafeHtml.defaultProps = {
	html: undefined,
	sx: undefined
};
